import React, { useEffect, useState } from 'react';
import {
  useRouteError,
  isRouteErrorResponse,
  useNavigate,
} from 'react-router-dom';
import { claimChunkReload, isChunkLoadError } from './utils/chunkReload';

export default function ErrorPage(): React.JSX.Element {
  const error = useRouteError();
  const navigate = useNavigate();
  const [shouldReload, setShouldReload] = useState(false);

  console.error(error);
  // ChunkLoadError 감지 및 처리 — 새 배포 후 옛 chunk 요청 실패. 새로고침으로 새 번들을 받는다.
  //  [2026-10-30] 일정 시간 안에 한 번만 자동 새로고침(utils/chunkReload.ts). 또 실패하면 아래 기본 화면의
  //  [새로고침] 버튼으로 사용자가 직접 — 배포 중 무한 새로고침(매번 공지 API 호출) 방지.
  useEffect(() => {
    if (isChunkLoadError(error) && claimChunkReload()) {
      console.warn('ChunkLoadError detected. Reloading page...');
      setShouldReload(true);
      // 약간의 지연 후 새로고침 (사용자에게 피드백 제공)
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
  }, [error]);

  let errorMessage: string = 'Unknown error';

  if (isRouteErrorResponse(error)) {
    errorMessage = error.statusText || 'Unknown error';
  } else if (error instanceof Error) {
    errorMessage = error.message;
  } else if (typeof error === 'string') {
    errorMessage = error;
  }

  // ChunkLoadError인 경우 새로고침 메시지 표시
  if (shouldReload) {
    return (
      <div
        id="error-page"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          padding: '20px',
          textAlign: 'center',
        }}
      >
        <h1>업데이트 중...</h1>
        <p>새 버전을 불러오는 중입니다. 잠시 후 자동으로 새로고침됩니다.</p>
      </div>
    );
  }

  return (
    <div
      id="error-page"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '20px',
        textAlign: 'center',
      }}
    >
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
      <p>
        <i>{errorMessage}</i>
      </p>
      <button
        onClick={() => navigate('/')}
        style={{
          marginTop: '20px',
          padding: '10px 20px',
          cursor: 'pointer',
          fontSize: '16px',
        }}
      >
        홈으로 돌아가기
      </button>
      <button
        onClick={() => window.location.reload()}
        style={{
          marginTop: '10px',
          padding: '10px 20px',
          cursor: 'pointer',
          fontSize: '16px',
        }}
      >
        페이지 새로고침
      </button>
    </div>
  );
}
